function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15.9 7.707a1 1 0 010 1.414l-4.95 4.95a.995.995 0 01-.53.277l-.118.014h-.118a.996.996 0 01-.648-.29l-2.829-2.83a1 1 0 011.414-1.414l2.121 2.121 4.243-4.242a1 1 0 011.414 0z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgSmall = function SvgSmall(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22
    }, props), _ref)
  );
};

export default SvgSmall;